export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResidenciaProfesionalPage.vue?vue&type=template&id=2cdd9bcc&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ResidenciaProfesionalPage.vue?vue&type=template&id=2cdd9bcc&scoped=true&
// module id = 640
// module chunks = 8